import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { lightSkeletonTheme, darkSkeletonTheme } from "./skeletonTheme";

// Mirrors Shop.jsx's current editorial layout: dark masthead, featured filmstrip,
// filter toolbar, and product list so the page feels stable while content loads.
const ShopSkeleton = ({ navHeight }) => {
  return (
    <div
      className="bg-[rgba(250,248,251,0.88)]"
      style={{
        minHeight: navHeight ? `calc(100vh - ${navHeight}px)` : undefined,
      }}
    >
      <section className="bg-primary-dark px-6 py-10 md:px-12">
        <SkeletonTheme {...darkSkeletonTheme}>
          <div className="py-12 md:py-14 text-left">
            <Skeleton
              width="58%"
              height={74}
              containerClassName="block mb-4"
              className="!max-w-[920px]"
            />
            <Skeleton
              width="42%"
              height={28}
              containerClassName="block"
              className="!max-w-[680px]"
            />
          </div>
        </SkeletonTheme>
      </section>

      <div className="flex flex-nowrap bg-primary-dark">
        <SkeletonTheme {...darkSkeletonTheme}>
          <Skeleton
            className="!h-[clamp(220px,28vw,420px)]"
            containerClassName="w-full sm:w-auto sm:min-w-0 sm:flex-[1.6] flex"
            borderRadius={0}
          />
          <Skeleton
            className="!h-[clamp(220px,28vw,420px)]"
            containerClassName="hidden sm:flex sm:min-w-0 sm:flex-1"
            borderRadius={0}
          />
          <Skeleton
            className="!h-[clamp(220px,28vw,420px)]"
            containerClassName="hidden md:flex md:min-w-0 md:flex-1"
            borderRadius={0}
          />
          <Skeleton
            className="!h-[clamp(220px,28vw,420px)]"
            containerClassName="hidden lg:flex lg:min-w-0 lg:flex-1"
            borderRadius={0}
          />
        </SkeletonTheme>
      </div>

      <section className="bg-gradient-to-br from-primary-dark to-primary-medium/80 px-6 py-5 md:px-12">
        <div className="outer-container container">
          <SkeletonTheme {...darkSkeletonTheme}>
            <div className="flex flex-wrap items-center gap-3">
              <Skeleton width={150} height={42} borderRadius={9999} />
              <Skeleton width={134} height={42} borderRadius={9999} />
              <Skeleton width={112} height={42} borderRadius={9999} />
            </div>
          </SkeletonTheme>
        </div>
      </section>

      <div className="outer-container container px-3 pt-10">
        <SkeletonTheme {...lightSkeletonTheme}>
          <div className="mb-8 text-left">
            <Skeleton width={120} height={16} containerClassName="block mb-2" />
            <Skeleton width={360} height={40} />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mb-6">
            {Array.from({ length: 12 }).map((_, idx) => (
              <div
                key={idx}
                className="group relative flex h-full flex-col overflow-hidden rounded-xl border-2 border-primary-light/30 bg-white shadow-sm"
              >
                <Skeleton className="aspect-square" borderRadius={0} />
                <div className="flex-1 p-3 text-left">
                  <Skeleton
                    width="72%"
                    height={16}
                    containerClassName="block mb-2"
                  />
                  <Skeleton width="36%" height={14} />
                </div>
              </div>
            ))}
          </div>
        </SkeletonTheme>
      </div>
    </div>
  );
};

export default ShopSkeleton;
